import { useCallback } from 'react';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import EditTagsModal from './EditTagsModal';

export const useEditTagsModal = () => {
  const { openModal } = useDynamicModal();

  const openEditTagsModal = useCallback(
    ({ teamId }: { teamId: number }) => {
      openModal({ modal: ({ toggle }) => <EditTagsModal teamId={teamId} onClose={toggle} /> });
    },
    [openModal],
  );

  return { openEditTagsModal };
};

export default useEditTagsModal;
